// Kohteet karttatasona: mitkä kohteet piirretään kartalle.
// Taso on oma valintansa (Kartta → Tasot → "Kohteet"); oletuksena päällä, ja vain nimenomainen false piilottaa sen,
// jotta vanha tallennettu asetus (ilman tätä avainta) ei piilota kohteita.
// Kohteet-listasta valittu kohde (selectedId) näytetään aina, vaikka taso olisi piilotettu.
// Kohde ilman koordinaattia ei ole kartalla: sillä ei ole paikkaa, jonka voisi piirtää.

const hasPlace = (p) => Number.isFinite(p.lat) && Number.isFinite(p.lon);

/** Piirrettävät kohteet: ne, joilla on sijainti, ja vain jos taso on päällä (valittu kohde aina). */
export function visiblePois(content, overlays, selectedId = null) {
  const pois = (content?.pois ?? []).filter(hasPlace);
  return overlays?.pois === false ? pois.filter((p) => p.id === selectedId) : pois;
}

/** Kohteen ympäristö, johon kartta tarkennetaan: tunnistusalue näkyviin, vähintään noin 200 m:n alue. */
export function poiBounds(poi) {
  if (!hasPlace(poi)) return null;
  const radius = Math.max(Number(poi.visit_radius_m) || 40, 100) * 1.6; // metriä kohteen ympärillä
  const dLat = radius / 111_320;
  const dLon = radius / (111_320 * Math.cos((poi.lat * Math.PI) / 180));
  return [
    [poi.lat - dLat, poi.lon - dLon],
    [poi.lat + dLat, poi.lon + dLon],
  ];
}
